<template>
  <el-dialog
    title="考证目标"
    :visible.sync="visible"
    class="width984"
    :append-to-body="true"
    @close="close"
  >
    <el-form ref="form" :model="form" label-position="top">
      <el-form-item label="证书类型：" prop="ClassifyID">
        <el-select
          style="width: 100%"
          v-model="form.ClassifyID"
          placeholder="请选择"
          :disabled="type == 2"
          @change="getCertificateList"
        >
          <el-option
            v-for="it in certificateTypeList"
            :label="it.ClassifyName"
            :value="it.ClassifyID"
            :key="it.ClassifyID"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证书分类名称：" prop="CertName">
        <el-select
          style="width: 100%"
          v-model="form.CertName"
          placeholder="请选择"
          :disabled="type == 2 || certificateList.length == 0"
          @change="getCertLevelList"
        >
          <el-option
            v-for="it in certificateList"
            :label="it.CertName"
            :value="it.CertName"
            :key="it.CertName"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="证书级别：" prop="CertLevel">
        <el-select
          style="width: 100%"
          v-model="form.CertLevel"
          placeholder="请选择"
          :disabled="type == 2 || CertLevels.length == 0"
          @change="getTypeId"
        >
          <el-option
            v-for="it in CertLevels"
            :label="it.CertLevel"
            :value="it.CertLevel"
            :key="it.CertLevel"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="计划考试时间：">
        <el-date-picker
          v-model="form.PlanTime"
          value-format="yyyy-MM-dd"
          type="date"
          :disabled="type == 2"
          placeholder="请选择"
          style="width: 100%"
        />
      </el-form-item>
    </el-form>
    <div v-if="type != 2" slot="footer">
      <el-button class="submit-btn" @click="submit()">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  GetMyCertTargetDetail,
  CertType_GetTreeList,
  Classify_GetList,
  MyCertTargetEdit,
} from "@/api/member";

export default {
  props: {
    id: [String, Number],
    type: [String, Number],
  },
  watch: {
    type(val) {
      if (Number(val) > 0) {
        this.getInfo();
      }
    },
  },
  data() {
    return {
      visible: false,
      noneBtnImg: false,
      certificateTypeList: [], //证书类型
      certificateList: [], //证书分类
      CertLevels: [], //证书级别
      form: {
        CertTypeID: "",
        ClassifyID: "",
        ClassifyName: "",
        CertLevel: "",
        PlanTime: "",
      },
    };
  },

  methods: {
    getTypeId(val) {
      const data = this.CertLevels.find((item) => item.CertLevel == val);
      this.form.CertTypeID = data.CertTypeID;
    },
    getCertLevelList(val) {
      const data = this.certificateList.find((item) => item.CertName == val);
      this.CertLevels = data.CertLevels;
    },
    // 证书分类列表
    getCertificateList(val) {
      let that = this;
      that.form.CertLevel = "";
      that.form.CertTypeID = "";
      that.certificateList = [];
      CertType_GetTreeList({ ClassifyID: val }).then((res) => {
        if (res.code != 0) {
          that.$message.warning(res.msg);
          return false;
        }
        that.certificateList = res.data || [];
        that.CertLevels = [];
      });
    },
    getClassifyList() {
      let that = this;
      Classify_GetList().then((res) => {
        that.certificateTypeList = res.data;
      });
    },
    getInfo() {
      GetMyCertTargetDetail({
        TargetID: this.id,
      }).then((res) => {
        this.form = { ...this.form, ...res.data };
        this.setInfo(res.data);
      });
    },
    setInfo(data) {
      let that = this;
      that.form.CertLevel = "";
      that.form.CertTypeID = "";
      that.certificateList = [];
      CertType_GetTreeList({ ClassifyID: data.ClassifyID }).then((res) => {
        that.certificateList = res.data || [];
        that.getCertLevelList(data.CertName);
        that.form.CertTypeID = data.CertTypeID;
        that.form.CertLevel = data.CertLevel;
      });
    },
    submit() {
      const dd = this.certificateTypeList.find(
        (o) => o.ClassifyID == this.form.ClassifyID
      );
      if (!dd) {
        this.$message.error("请选择证书类型");
        return false;
      }
      if (!this.form.CertName) {
        this.$message.error("请选择证书分类");
        return false;
      }
      if (!this.form.CertLevel) {
        this.$message.error("请选择证书级别");
        return false;
      }
      const data = {
        ...this.form,
        ClassifyName: dd.ClassifyName,

        TargetID: this.id || 0,
      };
      MyCertTargetEdit(data).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.close(true);
        } else {
        }
      });
    },
    open() {
      this.getClassifyList();
      this.visible = true;
    },
    close(flag) {
      this.visible = false;
      this.form = {
        CertTypeID: "",
        ClassifyID: "",
        ClassifyName: "",
        CertLevel: "",
        PlanTime: "",
      };
      if (flag) {
        this.$emit("closePop");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.width984 {
  ::v-deep .el-dialog {
    width: 535px;
  }
  ::v-deep .el-input.is-disabled .el-input__inner {
    background: #ffffff;
    font-size: 16px;
    color: #333333;
  }
  ::v-deep .el-input__inner {
    height: 46px !important;
    background: #ffffff;
    font-size: 16px;
    border-radius: 6px;
    border: 1px solid #e6e6e6;
  }
  .width100 {
    ::v-deep .el-date-editor {
      font-size: 16px;
      width: 100% !important;
    }
  }
}
.submit-btn {
  width: 144px;
  height: 52px;
  background: #1d79ff;
  border-radius: 6px;
  font-size: 18px;
  color: #ffffff;
}
</style>
